import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Widgets from "../../../widgets";
import { getPatientHistory } from "../../../modules/NursignCare/ManageRequest/manageRequestThunk";
import strings from "../../../utils/strings";
import Icons from "../../../Assets/Icons";
import SearchIcon from "../../../Assets/Icons/Search.png";
import "./SearchPatientHistory.css";

const SearchPatientHistory = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [hnNumber, setHnNumber] = useState("");
    const [error, setError] = useState(false);
    const [isSearched, setIsSearched] = useState(false);

    const breadcrumbs = ["nursingCare", "patientHistory"];
    const paths = [
        { path: strings.navigation.nursingCareManageService },
        { path: strings.navigation.patientHistory },
    ];

    const handleSearch = async (searchQuery) => {
        setIsSearched(true);
        const trimmedQuery = searchQuery.trim();
        setHnNumber(trimmedQuery);

        if (!trimmedQuery) {
            setError(false);
            return;
        }

        try {
            await dispatch(getPatientHistory({ hnNumber: trimmedQuery })).unwrap();
            setError(false);
            navigate(`${strings.navigation.patientHistoryDetails.replace(":hnNumber", trimmedQuery)}`);
        } catch (e) {
            setError(true);
        }
    };

    return (
        <div className="sph-container">
            <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
            <div className="department-heading">
                <div>{t("patientHistoryViewer")}</div>
            </div>

            <div className="">
                <div className="sph-search-box">
                    <Widgets.SearchBox
                        onSearch={handleSearch}
                        placeholder="searchToViewHN"
                    />
                </div>

                {!isSearched && (
                    <div className="sph-empty-state">
                        <div className="sph-icon-container">
                            <img src={SearchIcon} alt="search" className="sph-search-icon" />
                        </div>
                        <p className="sph-message">{t("searchToViewHN")}</p>
                    </div>
                )}

                {isSearched && error && (
                    <div className="sph-error-state">
                        <div className="sph-error-icon-container">
                            <img src={Icons.NoData} alt="no record" className="sph-error-icon" />
                        </div>
                        <p className="sph-error-message">{t("noPatientFound")}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchPatientHistory;
